// This import loads the firebase namespace along with all its type information.
import Series from './series-model'

export async function load_seriess(): Promise<Series[]> {
  throw 'Not implemented'
}

export async function delete_series(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_series(): Promise<Series> {
  throw 'Not implemented'
}
